export const CatValidateFields = (values) => {
    let errors = {};

    if (!values?.name?.trim()) {
        errors.name = "Category name field is required";
    }
    return errors
}